<template>
  <div class="space-banner-wrap">
    <div v-if="bannerList.length > 0"
         class="banner-wrap">
      <swiper :slides-per-view="1"
              :space-between="0"
              :loop="bannerList.length > 1"
              :autoplay="{ delay: 4000, disableOnInteraction: false }"
              :pagination="{ clickable: true }"
              :navigation="!isMobileDevice && bannerList.length > 1"
              :modules="[Autoplay, Pagination, Navigation]"
              class="banner-swiper">
        <swiper-slide v-for="(banner) in bannerList"
                      :key="banner.id">
          <div class="slide-wrap"
               @click="handleBannerClick(banner)">
            <NuxtImg format="webp"
                     quality="80"
                     placeholder
                     :src="picUrl + banner.photo_url"
                     :alt="banner.subject"/>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <el-skeleton v-else
                 class="flex w-full"
                 :throttle="500"
                 :loading="true"
                 animated>
      <template #template>
        <el-skeleton-item variant="image"
                          class="w-full aspect-[1366/400] rounded-[20px]"/>
      </template>
    </el-skeleton>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import {Autoplay, Pagination, Navigation} from "swiper/modules";
import {bannerDetail, banners} from "@/api/banner";
import {useSearchWithStore} from "@/composables/useSearchWithStore";
import {useGoTo} from "@/composables/useGoTo";
import {useRouter} from "nuxt/app";
import {useSettingStore} from "@/stores/setting";
import {useSearchQueryStore} from "@/stores/searchQuery";

const {go, toWebsite} = useGoTo();
const router = useRouter();
const {handleSearchWithStore} = useSearchWithStore()
const searchQueryStore = useSearchQueryStore()
const settingStore = useSettingStore()

const picUrl = ref(import.meta.env.VITE_APP_BASE_IMG_URL)

const bannerList = ref([])

const isMobile = computed(() => settingStore.isMobile);
const {isMobileSSr} = useDevice();
const isMobileDevice = computed(() => isMobileSSr || isMobile.value);

// 使用 useAsyncData 來抓取 banner 資料
const {data: bannersData} = await useAsyncData(
    'bannersData',
    () => banners());

bannerList.value = bannersData.value?.list || []

async function handleBannerClick(banner) {
  switch (banner.type) {
    case 1:
      router.push({path: 'banner/' + banner.id});
      break;
    case 2:
      const res2 = await bannerDetail(banner.id)
      toWebsite(res2.data1)
      break;
    case 3:
      const res3 = await bannerDetail(banner.id)
      const searchJsonObj = JSON.parse(res3.data1)
      /// 清掉原本條件
      searchQueryStore.initQueryDate()
      searchQueryStore.setSelectedCityID(searchJsonObj.filter_options.city_ids)
      searchQueryStore.setSelectedCategoryObject(searchJsonObj.filter_options.category_ids)
      /// 搜尋
      handleSearchWithStore()
      /// go
      go('/search-result')
      break;
  }
}

</script>

<style scoped
       lang="scss">

.space-banner-wrap {
  @apply relative mx-auto
  pc:px-[130px] pc:mt-[20px] pc:max-w-[1366px]
  mobile:mt-[12px] mobile:px-[12px];

  .banner-wrap {
    .banner-swiper {
      @apply rounded-[20px] overflow-hidden;

      :deep(.swiper-pagination) {
        bottom: 12px;

        .swiper-pagination-bullet {
          @apply w-[10px] h-[10px] bg-white opacity-60;
        }

        .swiper-pagination-bullet-active {
          @apply opacity-100 bg-osn-yellow-00;
        }
      }

      :deep(.swiper-button-prev),
      :deep(.swiper-button-next) {
        @apply w-[44px] h-[44px] bg-white/70 rounded-full;

        &::after {
          @apply text-[18px] font-bold text-osn-dark-grey-00;
        }
      }
    }

    .slide-wrap {
      @apply relative cursor-pointer;

      img {
        @apply w-full object-cover aspect-[1366/400] mobile:aspect-[375/200];
      }
    }
  }
}
</style>
